import React from 'react';
import { Button } from './ui/button';
import { CheckSquare, Square, Power, PowerOff, Trash2, X } from 'lucide-react';
import { Badge } from './ui/badge';

export const BulkActionToolbar = ({ 
  selectedCount, 
  totalCount,
  onSelectAll, 
  onDeselectAll, 
  onBulkActivate, 
  onBulkDeactivate, 
  onBulkDelete 
}) => {
  const allSelected = selectedCount === totalCount && totalCount > 0;

  return (
    <div 
      className="bg-blue-50 border border-blue-200 rounded-lg p-4 flex items-center justify-between"
      data-testid="bulk-action-toolbar"
    >
      <div className="flex items-center gap-4">
        <Button
          variant="outline"
          size="sm"
          onClick={allSelected ? onDeselectAll : onSelectAll}
          data-testid="toggle-select-all-button"
          className="flex items-center gap-2"
        >
          {allSelected ? (
            <>
              <Square className="h-4 w-4" />
              Deselect All
            </>
          ) : (
            <>
              <CheckSquare className="h-4 w-4" />
              Select All
            </>
          )}
        </Button>
        
        <div className="flex items-center gap-2">
          <span className="text-sm font-medium text-gray-700">Selected:</span>
          <Badge variant="default" className="bg-blue-600" data-testid="selected-count">
            {selectedCount}
          </Badge>
        </div>
      </div>

      {selectedCount > 0 && (
        <div className="flex items-center gap-2">
          <Button
            variant="default"
            size="sm"
            onClick={onBulkActivate}
            data-testid="bulk-activate-button"
            className="bg-green-600 hover:bg-green-700 text-white flex items-center gap-2"
          >
            <Power className="h-4 w-4" />
            Activate ({selectedCount})
          </Button>
          
          <Button
            variant="default"
            size="sm"
            onClick={onBulkDeactivate}
            data-testid="bulk-deactivate-button"
            className="bg-orange-600 hover:bg-orange-700 text-white flex items-center gap-2"
          >
            <PowerOff className="h-4 w-4" />
            Deactivate ({selectedCount})
          </Button>
          
          <Button
            variant="destructive"
            size="sm"
            onClick={onBulkDelete}
            data-testid="bulk-delete-button"
            className="flex items-center gap-2"
          >
            <Trash2 className="h-4 w-4" />
            Delete ({selectedCount})
          </Button>
          
          <Button
            variant="ghost"
            size="sm"
            onClick={onDeselectAll}
            data-testid="clear-selection-button"
          >
            <X className="h-4 w-4" />
          </Button>
        </div>
      )}
    </div>
  );
};
